import { render, staticRenderFns } from "./UserRolePermissions.vue?vue&type=template&id=2fd66fc6"
import script from "./UserRolePermissions.vue?vue&type=script&lang=ts"
export * from "./UserRolePermissions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports